import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { pickAriaProps } from '../../utils/aria/aria';
import { pickDataAttributes } from '../../utils/pickDataAttributes/pickDataAttributes';
import { TextStyled } from './text.styled';
const TextStandAloneComponent = ({ dataTestId = 'text', transform, ...props }, ref) => {
    const ariaProps = pickAriaProps(props);
    const dataAttributes = pickDataAttributes(props);
    return (_jsx(TextStyled, { ...props, ...ariaProps, ...dataAttributes, ref: ref, "$maxTruncatedLines": props.maxTruncatedLines, "$transform": transform, "$truncate": props.truncate, align: props.align, as: props.component, content: undefined, "data-testid": dataTestId, htmlFor: props.htmlFor, id: props.id, isDisabled: props.isDisabled, role: props.role, styles: props.styles, weight: props.weight, onClick: props.onClick, children: props.children }));
};
/**
 * @description
 * Text component is a component that can be used to create a text.
 * @param {React.PropsWithChildren<ITextStandAlone>} props
 * @returns {JSX.Element}
 * @constructor
 */
export const TextStandAlone = React.forwardRef(TextStandAloneComponent);
//# sourceMappingURL=textStandAlone.js.map